// import store from '../store/index';

// export function isLoggedIn() {

// }

// export function login() {
//     const token = {
//         username: 'kevin'
//     }

// }

// function setToken(token) {
//     localStorage.setItem('token', token);
//     store.dispatch('authenticate');
// }

// export function getUsername() {
//     return 'kevin';
// }

// export function getUserId() {
//     return 1;
// }

import api from "./api";

const BASE_SERVICE_URL = "merchant-service";

export default {
  registerUser(payload) {
    return new Promise((resolve, reject) => {
      api.post(
        `${BASE_SERVICE_URL}/v1/self-serve/register`,
        payload
      )
      .then(response => {
        return resolve(response);
      })
      .catch((status, errors) => {
        reject(status, errors);
      });
    });
  },
  getPlanList(planType) {
    return new Promise((resolve, reject) => {
      api.get(
        `${BASE_SERVICE_URL}/v1/self-serve/plan/${planType}/list`
      )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  verifyEmail(code) {
    return new Promise((resolve, reject) => {
      api.post(
        'merchant-auth-service/v1/self-serve/user/confirm-email',
        code
      )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  registerValidate(payload) {
    return new Promise((resolve, reject) => {
      api.post(
        `${BASE_SERVICE_URL}/v1/self-serve/register/validate`,
        payload
      )
      .then(response => {
        return resolve(response);
      })
      .catch((status, errors) => {
        reject(status, errors);
      });
    });
  },
};
